import {
  Circle,
  Icon,
  SkeletonText,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RemixiconComponentType } from "@remixicon/react";

interface Props extends StackProps {
  title: string;
  value: any;
  icon: RemixiconComponentType;
  color: string;
  btnTitle?: string;
  handleClick?: () => void;
  loaded: boolean;
}

export const CardInfo = ({
  title,
  value,
  icon,
  color,
  btnTitle,
  handleClick,
  loaded,
  ...rest
}: Props) => {
  return (
    <VStack
      bg={`${color}.200`}
      className="card-info"
      p={4}
      gap={0}
      borderRadius={"md"}
      color={"black"}
      textAlign={"center"}
      {...rest}
    >
      <VStack justify={"space-between"}>
        <Circle bgColor={`${color}.300`} p={2}>
          <Icon as={icon} fontSize={[26, null, 28]} />
        </Circle>
      </VStack>

      <SkeletonText isLoaded={loaded} noOfLines={1}>
        <Text textStyle={"h-title"} mt={[2, null, 4]} fontWeight={"semibold"}>
          {value}
        </Text>
      </SkeletonText>

      <Text textStyle={"b-reg"}>{title}</Text>
    </VStack>
  );
};
